import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useDeleteScrapRule } from '../../hooks/maintenanceScrapRules/useDeleteScrapRule'
import { useGoBack } from '@/common/hooks/useGoBack'

interface ModalDeleteScrapRuleProps {
  scrapRuleId?: string
  companyId?: string
  onError?: (error: ErrorResponse) => void
}

export const ModalDeleteScrapRule = ({ scrapRuleId, companyId, onError }: ModalDeleteScrapRuleProps) => {
  const queryClient = useQueryClient()
  const goBack = useGoBack()

  const [isOpen, setIsOpen] = useState(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['scrapRule', scrapRuleId] })
    queryClient.invalidateQueries({ queryKey: ['scrapRules'] })
    goBack({fallback: `/companies/${companyId}/maintenance/scrap-rules`})
  }

  const { mutate: deleteScrapRule, isPending: deleteScrapRuleIsPending } = useDeleteScrapRule({
    onSuccess,
    onError: (error) => {
      setIsOpen(false)
      onError?.(error)
    },
  })

  return (
    <Modal
      Trigger={
        <Button operationKlassToCheckPermission='Admin::Maintenance::ScrapRules::Destroy' type="button" variant="outline-error">
          Deletar
        </Button>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Deletar regra"
      disabled={deleteScrapRuleIsPending}
      onConfirm={() => deleteScrapRule(scrapRuleId)}
    />
  )
}
